import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { scrollToElement } from 'src/app/shared';
import { SubSink } from 'subsink';
import { DynamicEventBindService, Session } from '../..';
import { getUrlParams } from '../../../shared';
import { ConfigurationService } from '../../services/configuration.service';
import { StickyMenuComponent } from '../../../shared/components/controls/sticky-menu/sticky-menu.component';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-learning-center-liability-base',
    template: `
    <div #dynamicContentContainer class="tw-w-full tw-flex">
      <!-- CONTENT -->
      <div class="tw-grow">
        @if (isIntroduction) {
          <h2
            class="app-lc-header-2"
            id="lc-intro"
            role="heading"
          >
            {{ ('Introduction'+ ' - ' + lobFullName) | translation: translationRequest }}
          </h2>
        }
        <div class="app-lc-text">
          <p>
            <span
              class="tw-text-lg"
              [innerHTML]="learningCenter.introductionResults[1]?.value"
            ></span>
          </p>
          @if (isMgr) {
            <p>
              {{
                learningCenter.introductionResults[2]?.value +
                  learningCenter.introductionResults[3]?.value
              }}
            </p>
          } @else {
            <p>
              {{
                learningCenter.introductionResults[2]?.value +
                  learningCenter.introductionResults[3]?.value
              }}
            </p>
          }
        </div>

        <h2 class="app-lc-header-2" id="lc-sub" role="heading">
          {{ 'Submitting Claim Information' | translation: translationRequest }}
        </h2>
        <div>
          <app-learning-center-section
            label="{{ learningCenter.submittingclaiminformations[0]?.value }}"
            icon="1"
            layout="bullet"
          >
            @if (isMgr) {
              <span
                [innerHTML]="
                  learningCenter.submittingclaiminformations[1]?.value
                "
              ></span
              ><span
                [innerHTML]="
                  learningCenter.submittingclaiminformations[2]?.value
                "
              ></span>
            } @else {
              <span
                [innerHTML]="
                  learningCenter.submittingclaiminformations[1]?.value
                "
              ></span
              ><span
                [innerHTML]="
                  learningCenter.submittingclaiminformations[2]?.value
                "
              ></span>
              @if (!claimClosed && isClaimSpecific) {
                <p
                  [innerHTML]="
                    learningCenter.submittingclaiminformations[3]?.value
                  "
                ></p>
              }
            }
          </app-learning-center-section>

          @if (isMgr) {
            @if (isController) {
              <app-learning-center-section
                label="{{
                  learningCenter.submittingclaiminformations[3]?.value
                }}"
                icon="2"
                layout="bullet"
              >
                <p
                  [innerHTML]="
                    learningCenter.submittingclaiminformations[4]?.value
                  "
                ></p>
              </app-learning-center-section>
              <app-learning-center-section
                label="{{
                  learningCenter.submittingclaiminformations[5]?.value
                }}"
                icon="3"
                layout="bullet"
              >
                <div
                  class="tw-w-full tw-flex tw-flex-col md:tw-flex-row tw-flex-wrap tw-justify-items-stretch"
                >
                  @if (showUpload) {
                    <app-learning-center-section
                      class="tw-basis-1/4 app-color-teal"
                      layout="icon-small"
                      icon="upload_file"
                    >
                      <a
                        tabindex="0"
                        label="Documents"
                        class="go-to-documents-upload"
                        (click)="redirectToDocUpload()"
                        >{{ 'Upload documents' | translation: translationRequest }}</a
                      >
                    </app-learning-center-section>
                  }
                  @if (learningCenter.submittingclaiminformations[6]?.value) {
                    <app-learning-center-section
                      class="tw-basis-1/4"
                      layout="icon-small"
                      icon="mail"
                    >
                      {{ 'Mail' | translation: translationRequest }}:<br />
                      <p
                        [innerHTML]="
                          learningCenter.submittingclaiminformations[6]?.value
                        "
                      ></p>
                    </app-learning-center-section>
                  }
                  @if (learningCenter.submittingclaiminformations[7]?.value) {
                    <app-learning-center-section
                      class="tw-basis-1/4"
                      layout="icon-small"
                      icon="fax"
                    >
                      {{ 'Fax' | translation: translationRequest }}:<br />
                      <p
                        [innerHTML]="
                          learningCenter.submittingclaiminformations[7]?.value
                        "
                      ></p>
                    </app-learning-center-section>
                  }
                  @if (learningCenter.submittingclaiminformations[8]?.value) {
                    <app-learning-center-section
                      class="tw-basis-1/4"
                      layout="icon-small"
                      icon="laptop_mac"
                    >
                      {{ 'Email' | translation: translationRequest }}:<br />
                      <p
                        [innerHTML]="
                          learningCenter.submittingclaiminformations[8]?.value
                        "
                      ></p>
                    </app-learning-center-section>
                  }
                </div>
              </app-learning-center-section>
            } @else {
              <app-learning-center-section
                label="{{
                  learningCenter.submittingclaiminformations[4]?.value
                }}"
                icon="2"
                layout="bullet"
              >
                <p
                  [innerHTML]="
                    learningCenter.submittingclaiminformations[5]?.value
                  "
                ></p>
              </app-learning-center-section>
              <app-learning-center-section
                label="{{
                  learningCenter.submittingclaiminformations[7]?.value
                }}"
                icon="3"
                layout="bullet"
              >
                <div
                  class="tw-w-full tw-flex tw-flex-col md:tw-flex-row tw-flex-wrap tw-justify-items-stretch"
                >
                  @if (showUpload) {
                    <app-learning-center-section
                      class="tw-basis-1/4 app-color-teal"
                      layout="icon-small"
                      icon="upload_file"
                    >
                      <a
                        tabindex="0"
                        label="Documents"
                        class="go-to-documents-upload"
                        (click)="redirectToDocUpload()"
                        >{{ 'Upload documents' | translation: translationRequest }}</a
                      >
                    </app-learning-center-section>
                  }
                  @if (learningCenter.submittingclaiminformations[8]?.value) {
                    <app-learning-center-section
                      class="tw-basis-1/4"
                      layout="icon-small"
                      icon="mail"
                    >{{ 'Mail' | translation: translationRequest }}:<br />
                      <p
                        [innerHTML]="
                          learningCenter.submittingclaiminformations[8]?.value
                        "
                      ></p>
                    </app-learning-center-section>
                  }
                  @if (learningCenter.submittingclaiminformations[9]?.value) {
                    <app-learning-center-section
                      class="tw-basis-1/4"
                      layout="icon-small"
                      icon="fax"
                    >
                      {{ 'Fax' | translation: translationRequest }}:<br />
                      <p
                        [innerHTML]="
                          learningCenter.submittingclaiminformations[9]?.value
                        "
                      ></p>
                    </app-learning-center-section>
                  }
                  @if (learningCenter.submittingclaiminformations[10]?.value) {
                    <app-learning-center-section
                      class="tw-basis-1/4"
                      layout="icon-small"
                      icon="laptop_mac"
                    >
                      {{ 'Email' | translation: translationRequest }}:<br />
                      <p
                        [innerHTML]="
                          learningCenter.submittingclaiminformations[10]?.value
                        "
                      ></p>
                    </app-learning-center-section>
                  }
                </div>
              </app-learning-center-section>
            }
          } @else {
            @if (isController) {
              <app-learning-center-section
                label="{{
                  learningCenter.submittingclaiminformations[3]?.value
                }}"
                icon="2"
                layout="bullet"
              >
                <p
                  [innerHTML]="
                    learningCenter.submittingclaiminformations[4]?.value
                  "
                ></p>
              </app-learning-center-section>
              <app-learning-center-section
                label="{{
                  learningCenter.submittingclaiminformations[5]?.value
                }}"
                icon="3"
                layout="bullet"
              >
                <div
                  class="tw-w-full tw-flex tw-flex-col md:tw-flex-row tw-flex-wrap tw-justify-items-stretch"
                >
                  @if (showUpload) {
                    <app-learning-center-section
                      class="tw-basis-1/4 app-color-teal"
                      layout="icon-small"
                      icon="upload_file"
                    >
                      <a
                        tabindex="0"
                        label="Documents"
                        class="go-to-documents-upload"
                        (click)="redirectToDocUpload()"
                        >{{ 'Upload documents' | translation: translationRequest }}</a
                      >
                    </app-learning-center-section>
                  }
                  @if (learningCenter.submittingclaiminformations[6]?.value) {
                    <app-learning-center-section
                      class="tw-basis-1/4"
                      layout="icon-small"
                      icon="mail"
                    >
                      {{ 'Mail' | translation: translationRequest }}:<br />
                      <p
                        [innerHTML]="
                          learningCenter.submittingclaiminformations[6]?.value
                        "
                      ></p>
                    </app-learning-center-section>
                  }
                  @if (learningCenter.submittingclaiminformations[7]?.value) {
                    <app-learning-center-section
                      class="tw-basis-1/4"
                      layout="icon-small"
                      icon="fax"
                    >
                      {{ 'Fax' | translation: translationRequest }}:<br />
                      <p
                        [innerHTML]="
                          learningCenter.submittingclaiminformations[7]?.value
                        "
                      ></p>
                    </app-learning-center-section>
                  }
                  @if (learningCenter.submittingclaiminformations[8]?.value) {
                    <app-learning-center-section
                      class="tw-basis-1/4"
                      layout="icon-small"
                      icon="laptop_mac"
                    >
                      {{ 'Email' | translation: translationRequest }}:<br />
                      <p
                        [innerHTML]="
                          learningCenter.submittingclaiminformations[8]?.value
                        "
                      ></p>
                    </app-learning-center-section>
                  }
                </div>
              </app-learning-center-section>
            } @else {
              <app-learning-center-section
                label="{{
                  learningCenter.submittingclaiminformations[4]?.value
                }}"
                icon="2"
                layout="bullet"
              >
                <p
                  [innerHTML]="
                    learningCenter.submittingclaiminformations[5]?.value
                  "
                ></p>
                <p
                  [innerHTML]="
                    learningCenter.submittingclaiminformations[6]?.value
                  "
                ></p>
              </app-learning-center-section>
              <app-learning-center-section
                label="{{
                  learningCenter.submittingclaiminformations[7]?.value
                }}"
                icon="3"
                layout="bullet"
              >
                <div
                  class="tw-w-full tw-flex tw-flex-col md:tw-flex-row tw-flex-wrap tw-justify-items-stretch"
                >
                  @if (showUpload) {
                    <app-learning-center-section
                      class="tw-basis-1/4 app-color-teal"
                      layout="icon-small"
                      icon="upload_file"
                    >
                      <a
                        tabindex="0"
                        label="Documents"
                        class="go-to-documents-upload"
                        (click)="redirectToDocUpload()"
                        >{{ 'Upload documents' | translation: translationRequest }}</a
                      >
                    </app-learning-center-section>
                  }
                  @if (learningCenter.submittingclaiminformations[8]?.value) {
                    <app-learning-center-section
                      class="tw-basis-1/4"
                      layout="icon-small"
                      icon="mail"
                    >
                      {{ 'Mail' | translation: translationRequest }}:<br />
                      <p
                        [innerHTML]="
                          learningCenter.submittingclaiminformations[8]?.value
                        "
                      ></p>
                    </app-learning-center-section>
                  }
                  @if (learningCenter.submittingclaiminformations[9]?.value) {
                    <app-learning-center-section
                      class="tw-basis-1/4"
                      layout="icon-small"
                      icon="fax"
                    >
                      {{ 'Fax' | translation: translationRequest }}:<br />
                      <p
                        [innerHTML]="
                          learningCenter.submittingclaiminformations[9]?.value
                        "
                      ></p>
                    </app-learning-center-section>
                  }
                  @if (learningCenter.submittingclaiminformations[10]?.value) {
                    <app-learning-center-section
                      class="tw-basis-1/4"
                      layout="icon-small"
                      icon="laptop_mac"
                    >
                      {{ 'Email' | translation: translationRequest }}:<br />
                      <p
                        [innerHTML]="
                          learningCenter.submittingclaiminformations[10]?.value
                        "
                      ></p>
                    </app-learning-center-section>
                  }
                </div>
              </app-learning-center-section>
            }
          }
        </div>

        @if (isWhatsnext) {
          <h2
            class="app-lc-header-2"
            id="lc-next"
            role="heading"
          >
            {{ learningCenter.whatsnexts[0]?.value }}
          </h2>
        }
        <div class="app-lc-text tw-flex">
          <div class="tw-grow">
            @if (isMgr) {
              <div class="right-wrap app-pl2 tw-hidden md:tw-block">
                <img
                  src="./assets/images/img_LC_WhatsNext_computer.webp"
                  width="141"
                  height="100"
                  alt=""
                />
              </div>
              <p [innerHTML]="learningCenter.whatsnexts[1]?.value"></p>
              <p [innerHTML]="learningCenter.whatsnexts[2]?.value"></p>
              <p [innerHTML]="learningCenter.whatsnexts[3]?.value"></p>
              @if (learningCenter.whatsnexts[7]?.value) {
                <p
                  [innerHTML]="learningCenter.whatsnexts[4]?.value"
                ></p>
              }
              <div>
                @if (learningCenter.whatsnexts[7]?.value) {
                  <app-learning-center-section
                    label="{{ learningCenter.whatsnexts[5]?.value }}"
                    icon="contact_phone"
                    layout="icon"
                  >
                    <p
                      [innerHTML]="
                        learningCenter.whatsnexts[6]?.value +
                        ' ' +
                        learningCenter.whatsnexts[7]?.value +
                        ' ' +
                        learningCenter.whatsnexts[8]?.value
                      "
                    ></p>
                  </app-learning-center-section>
                }
              </div>
            } @else {
              <div class="right-wrap app-pl2 tw-hidden md:tw-block">
                <img
                  src="./assets/images/img_LC_WhatsNext_computer.webp"
                  width="141"
                  height="100"
                  alt=""
                />
              </div>
              <p [innerHTML]="learningCenter.whatsnexts[1]?.value"></p>
              <p [innerHTML]="learningCenter.whatsnexts[2]?.value"></p>
              <p [innerHTML]="learningCenter.whatsnexts[3]?.value"></p>

              @if (
                learningCenter.whatsnexts[6]?.value ||
                learningCenter.whatsnexts[11]?.value ||
                (this.claimConfigService.getConfigFeatureAccess(
                  'notificationpreferences'
                ) &&
                  learningCenter.whatsnexts[8]?.value)
              ) {
                <p
                  [innerHTML]="learningCenter.whatsnexts[4]?.value"
                ></p>
              }
              <div>
                @if (
                  !claimClosed &&
                  isClaimSpecific &&
                  learningCenter.whatsnexts[6]?.value
                ) {
                  <app-learning-center-section
                    label="{{ learningCenter.whatsnexts[5]?.value }}"
                    icon="laptop_mac"
                    layout="icon"
                  >
                    <p [innerHTML]="learningCenter.whatsnexts[6]?.value"></p>
                  </app-learning-center-section>
                }

                @if (
                  this.claimConfigService.getConfigFeatureAccess(
                    'notificationpreferences'
                  ) && learningCenter.whatsnexts[8]?.value
                ) {
                  <app-learning-center-section
                    label="{{ learningCenter.whatsnexts[7]?.value }}"
                    icon="chat"
                    layout="icon"
                  >
                    <p [innerHTML]="learningCenter.whatsnexts[8]?.value"></p>
                  </app-learning-center-section>
                }

                @if (learningCenter.whatsnexts[11]?.value) {
                  <app-learning-center-section
                    label="{{ learningCenter.whatsnexts[9]?.value }}"
                    icon="contact_phone"
                    layout="icon"
                  >
                    <p
                      [innerHTML]="
                        learningCenter.whatsnexts[10]?.value +
                        ' ' +
                        learningCenter.whatsnexts[11]?.value +
                        ' ' +
                        learningCenter.whatsnexts[12]?.value
                      "
                    ></p>
                  </app-learning-center-section>
                }
              </div>
            }
          </div>
        </div>
         <div id='endOfElement' tabindex="-1">&nbsp;</div>
      </div>
      <!-- RHS MENU -->
      <div
        class="tw-hidden lg:tw-block tw-flex-none tw-max-w-[220px] app-lc-menu"
      >
        <app-sticky-menu
          #stickyMenu
          [currentSection]="currentSection"
          (sectionChange)="onSectionChange($event)"
        >
          <div class="app-pt2">
            <div class="app-lc-sticky-link">
              <b>{{ lobFullName | translation: translationRequest }}</b>
            </div>
            @if (isIntroduction) {
              <div
                class="app-lc-sticky-link"
                [class.active-sidelink]="currentSection === 'lc-intro'"
              >
                <a tabindex="0" (click)="scrollToSection('lc-intro')"
                  >{{ 'Introduction' | translation: translationRequest }}</a
                >
              </div>
            }

            <div
              class="app-lc-sticky-link"
              [class.active-sidelink]="currentSection === 'lc-sub'"
            >
              <a tabindex="0" (click)="scrollToSection('lc-sub')"
                >{{ 'Submitting Claim Information' | translation: translationRequest }}</a
              >
            </div>
            @if (isWhatsnext) {
              <div
                class="app-lc-sticky-link"
                [class.active-sidelink]="currentSection === 'lc-next'"
              >
                <a tabindex="0" (click)="scrollToSection('lc-next')"
                  >{{ "What's Next" | translation: translationRequest }}</a
                >
              </div>
            }
          </div>
        </app-sticky-menu>
      </div>
    </div>
  `,
    styles: [
        `
      .app-lc-text {
      }
      .active-link {
        background-color: var(--sed-grey-60-color) !important;
        color: unset !important;
        color: var(-sed-dynamic-black-color) !important;
        text-decoration: underline !important;
        text-decoration-thickness: 3px !important;
        text-decoration-color: var(-sed-dynamic-black-color) !important;
      }
      .app-lc-menu {
        border-left: 1px solid var(--color-light-grey);
        padding-left: 16px;
        margin-left: 16px;
      }
      .left-wrap {
        float: left;
      }
      .right-wrap {
        float: right;
      }
      .center {
        text-align: center;
      }
      .mat-icon {
        margin: auto;
      }
      p + p {
        margin-top: 10px;
      }
    `,
    ],
    standalone: false
})
export class LearningCenterLiabilityBaseComponent
  implements OnInit, AfterViewInit
{
  @Input()
  isMgr: boolean;

  @Input()
  learningCenter: any;

  @Input()
  loading: boolean;

  scrollToElement = scrollToElement;
  mappings: any;

  @Input()
  lobFullName: string = 'Liability';

  @Input()
  claimClosed: boolean;
  @Input()
  lcType: string;

  @Input()
  translationRequest: TranslationRequest;

  isClaimSpecific: boolean = false;
  showUpload: boolean = false;
  isIntroduction: boolean = false;
  isWhatsnext: boolean = false;
  isController: boolean = false;
  currentSection: string = 'lc-intro';
  @ViewChild('dynamicContentContainer') container: ElementRef;
  @ViewChild('stickyMenu') stickyMenu!: StickyMenuComponent;
  private unlistens: (() => void)[] = [];
  constructor(
    private session: Session,
    private router: Router,
    private bindEvents: DynamicEventBindService,
    public claimConfigService: ConfigurationService
  ) {}

  subs = new SubSink();

  async ngOnInit() {
    this.checkHeaderValues();
    this.mappings = [
      {
        selector: '.go-to-personal-notif',
        route: '/PreferencesPage',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
        },
      },
      {
        selector: '.go-to-comm-center',
        route: '/claims',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
          focus: 'comm-center',
        },
      },
      {
        selector: '.go-to-pharmacy-card',
        route: '/pharmacy-card',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
        },
      },
      {
        selector: '.go-to-documents',
        route: '/claims',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
          focus: 'DOCUMENTS',
        },
      },
      {
        selector: '.go-to-documents-upload',
        route: '/upload-documents-in-documentstab',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
          focus: 'documents',
          showDialog: true,
        },
      },
      {
        selector: '.go-to-documents-show',
        route: '/upload-documents-in-documentstab',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
          focus: 'documents',
          showDialog: false,
        },
      },
    ];
    this.checkViaClaim();
  }

  async checkViaClaim() {
    const params = getUrlParams();
    if (params.claimId != null) {
      this.isClaimSpecific = true;
    }
    const hasLC = await this.claimConfigService.getFeatureAccess(
      'uploaddocuments'
    );
    if (this.isClaimSpecific && hasLC) {
      this.showUpload = true;
    }
    if (this.lcType == 'CONTROLLER') {
      this.isController = true;
    }
  }

  ngAfterViewInit(): void {
    //angular's innerHTML attribute doesnt bind click events so have to do this
    this.unlistens = this.bindEvents.bindDynamicEvents(
      this.container,
      this.mappings
    );
  }

  ngOnDestroy(): void {
    this.unlistens.forEach((unlisten) => unlisten());
  }

  checkHeaderValues() {
    if (this.checkArrayValue(this.learningCenter.introductionResults, 0)) {
      this.isIntroduction = true;
    }

    if (this.checkArrayValue(this.learningCenter.whatsnexts, 0)) {
      this.isWhatsnext = true;
    }
  }
  checkArrayValue(arr: any[], index: number) {
    const arrVal = arr.slice();
    if (index > 0) {
      arrVal.splice(index - 1, 1);
      return arrVal.some((obj) => obj.value !== '');
    } else {
      return arrVal.some((obj) => obj.value !== '');
    }
  }

  redirectToDocUpload() {
    this.router.navigate(['../upload-documents-in-documentstab'], {
      queryParams: {
        source: this.learningCenter.claimInfo.source,
        claimId: this.learningCenter.claimInfo.claimId,
        focus: 'documents',
        showDialog: true,
      },
    });
  }

  onSectionChange(section: string) {
    this.currentSection = section;
  }

  scrollToSection(sectionId: string) {
    this.stickyMenu.scrollToSection(sectionId);
  }
}
